import React, { useState, useEffect } from 'react'
import moment from 'moment'
import { nanoid } from 'nanoid'
import { useQuery, useMutation, useLazyQuery } from '@apollo/react-hooks'
import {
  Modal, Select, message, DatePicker, Upload, Collapse, Row, Col,
} from 'antd'
import {
 last, isUndefined, isEmpty, pick, find,
} from 'lodash'
import {
  Div, H3, Button, Loading, P, SmallText, Icon,
} from 'konsys-ui'
import numeral from 'numeral'
import fileDownload from 'js-file-download'
import axios from 'axios'
import { FUEL_SUMMARIES_BY_MONTH, GASSTATION_FUEL_SUMMARY_BY_MONTH } from '../../constants/graphql/query'
import { IMPORT_FUEL_COST_SUMMARY } from '../../constants/graphql/mutation'
import { theme } from '../../styles/_variables'
import { Wrapper } from '../../components/truck-components'
import COMPANY_NAME, { ENUM } from '../../constants/company-name'
import { getAccessToken, getURL } from '../../utils/local-data-service'
import { readImportFleetCardExcelFile } from '../../utils/util-services'

const { color } = theme

const { Panel } = Collapse

const findInvalidData = data => data.map(eachRow => ({
    row: isUndefined(eachRow.date) || isUndefined(eachRow.officialName) || isUndefined(eachRow.totalPrice) ? eachRow.row : undefined,
  })).filter(v => !isUndefined(v.row))

const ImportFleetCardModal = ({
  importFleetCardModal, setImportFleetCardModal, doImport, importLoading,
}) => {
  const [data, setData] = useState()
  const [companyType, setCompanyType] = useState(ENUM.PADOONGRICH)
  const [file, setFile] = useState([])
  const [gasstationCompany, setGasstationCompany] = useState()
  return (
    <Modal
      title='นำเข้าข้อมูลจาก Fleet Card'
      visible={importFleetCardModal}
      destroyOnClose={true}
      onCancel={() => {
        setImportFleetCardModal(false)
        setCompanyType(ENUM.PADOONGRICH)
        setGasstationCompany()
        setData()
        setFile([])
      }}
      onOk={() => {
        const invalidData = findInvalidData(data)
        if (isEmpty(invalidData)) {
          doImport({
            variables: {
              companyType,
              data: data.map(eachRow => pick(eachRow, ['officialName', 'date', 'totalPrice', 'reference', 'quantity'])),
            },
          }).then((resp) => {
            if (resp.data?.ImportFuelCostSummary?.success) {
              message.success(resp.data?.ImportFuelCostSummary?.message)
              setImportFleetCardModal(false)
              setCompanyType(ENUM.PADOONGRICH)
              setGasstationCompany()
              setData()
              setFile([])
            } else message.error(resp.data?.ImportFuelCostSummary?.message)
          })
        } else {
          message.error(`มีข้อมูลผิดพลาด row ที่ ${invalidData.map(v => v.row).toString()}`)
        }
      }}
      okButtonProps={{
        disabled: importLoading || isUndefined(companyType) || isUndefined(data) || isEmpty(file),
        loading: importLoading,
      }}
      cancelButtonProps={{
        disabled: importLoading,
      }}
    >
      <Div width='100%' display='flex' flexDirection='column' justifyContent='center'>
        <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='baseline'>
          <P>บริษัท</P>
          <Select
            style={{ width: 300, margin: '0 0 16px 0' }}
            defaultValue={ENUM.PADOONGRICH}
            onChange={e => setCompanyType(e)}
          >
            <Select.Option value={ENUM.PADOONGRICH}>{COMPANY_NAME.PADOONGRICH}</Select.Option>
            <Select.Option value={ENUM.TRANSPORT}>{COMPANY_NAME.TRANSPORT}</Select.Option>
          </Select>
        </Div>
        <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='baseline' margin='0 0 16px 0'>
          <P>บริษัทน้ำมัน</P>
          <Select
            style={{ width: 200, margin: '0 0 16px 0' }}
            onChange={e => setGasstationCompany(e)}
          >
            <Select.Option value={'SHELL'}>SHELL</Select.Option>
            <Select.Option value={'BANGCHAK'}>BANGCHAK</Select.Option>
            <Select.Option value={'CALTEX'}>CALTEX</Select.Option>
            <Select.Option value={'ESSO'}>ESSO</Select.Option>
            <Select.Option value={'PTT'}>PTT</Select.Option>
          </Select>
        </Div>
        <Upload
          customRequest={() => null}
          processData={false}
          fileList={file}
          accept={'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
          onChange={(e) => {
            setFile(last(e.fileList) ? [last(e.fileList)] : [])
            if (last(e.fileList)) {
              readImportFleetCardExcelFile(gasstationCompany, last(e.fileList).originFileObj, (convertedFile) => {
                setData(convertedFile)
              })
            }
          }}
          beforeUpload={() => false}
          multiple={false}
        >
          <Button disabled={isUndefined(gasstationCompany)} loading={importLoading} inverse small text='อัพโหลดไฟล์' icon='far fa-file-upload' />
        </Upload>
      </Div>
    </Modal>
  )
}

const ExportFuelReportModal = ({
  exportFuelReportModal, setExportFuelReportModal, gasstationCompany,
}) => {
  const [loading, setLoading] = useState(false)
  const [range, setRange] = useState([])
  return (
    <Modal
      title='พิมพ์รายงานการเติมน้ำมัน'
      visible={exportFuelReportModal}
      destroyOnClose={true}
      onCancel={() => {
        setRange([])
        setExportFuelReportModal(false)
      }}
      onOk={() => {
        setLoading(true)
        axios({
          method: 'GET',
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
          url: `${getURL().FILE_SERVER}/download/excel/fuelOrder?${
            [
              `startDate=${moment(range[0]).format('YYYY-MM-DD')}`,
              `endDate=${moment(range[1]).format('YYYY-MM-DD')}`,
              `company=${gasstationCompany}`,
            ].join('&')
          }`,
        }).then((resp) => {
          fileDownload(resp.data, `รายงานการเติมน้ำมัน บริษัท ${gasstationCompany} วันที่ ${moment(range[0]).format('YYYY-MM-DD')} - ${moment(range[1]).format('YYYY-MM-DD')} .xlsx`)
          setLoading(false)
          setRange([])
          setExportFuelReportModal(false)
        })
      }}
      okButtonProps={{
        loading,
        disabled: loading || isUndefined(gasstationCompany) || range.length < 2,
      }}
      cancelButtonProps={{
        disabled: loading,
      }}
    >
      <Div width='100%' display='flex' flexDirection='column' justifyContent='center'>
        <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='baseline'>
          <P>วันที่</P>
          <DatePicker.RangePicker
            format='DD/MM/YYYY'
            onChange={(e) => {
              setRange(e)
            }}
          />
        </Div>
      </Div>
    </Modal>
  )
}

const GasstationSummaryModal = ({
  gasstationSummaryModal, setGasstationSummaryModal, month, company, gasstation,
}) => {
  const [getData, { data }] = useLazyQuery(GASSTATION_FUEL_SUMMARY_BY_MONTH)
  const [renderData, setRenderData] = useState([])

  useEffect(() => {
    if (gasstationSummaryModal && gasstation?.id) {
      getData({
        variables: { month, companyType: company, gasstationId: gasstation?.id },
      })
    }
  }, [gasstationSummaryModal, gasstation])

  useEffect(() => {
    if (data?.GasstationFuelSummaryByMonth?.data) {
      const tempData = []
      for (let i = moment(month).startOf('month'); moment(i).isSame(moment(month), 'month'); i = moment(i).add(1, 'day')) {
        const queryData = find(data?.GasstationFuelSummaryByMonth?.data, v => moment(v.date).isSame(moment(i), 'day'))
        if (queryData) {
          tempData.push(queryData)
        } else {
          tempData.push({ date: i })
        }
      }
      setRenderData(tempData)
    }
  }, [data?.GasstationFuelSummaryByMonth?.data])

  return (
    <Modal
      width='1080px'
      title={`${gasstation?.name} เดือน ${moment(month).format('MMMM YYYY')}`}
      visible={gasstationSummaryModal}
      destroyOnClose={true}
      onCancel={() => {
        setGasstationSummaryModal(false)
      }}
      footer={null}
    >
      <Row style={{ margin: '24px 0 0', padding: '8px 32px', borderBottom: '1px solid #5278A0' }}>
        <Col span={1}></Col>
        <Col span={3}><P bold style={{ width: '100%' }} textAlign='center'>วันที่</P></Col>
        <Col span={5}><P bold style={{ width: '100%' }} textAlign='center'>ยอดใน ERP ที่ไม่ใช้ Fleet Card</P></Col>
        <Col span={5}><P bold style={{ width: '100%' }} textAlign='center'>ยอดใน ERP ที่ใช้ Fleet Card</P></Col>
        <Col span={5}><P bold style={{ width: '100%' }} textAlign='center'>ยอด Fleet Card</P></Col>
        <Col span={5}><P bold style={{ width: '100%' }} textAlign='center'>เปรียบเทียบ</P></Col>
      </Row>
      {
        renderData.map((report, idx) => (
          <Div key={nanoid()} padding='0 32px' margin='8px 0' bgColor={theme.color.offWhite} style={{ borderRadius: '5px 0 0 5px' }}>
            <Row type='flex' align='top' style={{ margin: '0' }}>
              <Col span={1}><P style={{ width: '100%' }} textAlign='center'>{idx + 1}.</P></Col>
              <Col span={3}><P style={{ width: '100%' }} textAlign='center'>{moment(report.date).format('DD MMMM YYYY')}</P></Col>
              <Col span={5}>
                <Div display='flex' flexDirection='column'>
                  <P style={{ width: '100%' }} textAlign='center'>{numeral(report.erpNonFleetCost).format('0,0.00')}</P>
                  <SmallText color={theme.color.coolGrey} textAlign='center'>({report.erpNonFleetFuelQuantity || 0} ลิตร)</SmallText>
                </Div>
              </Col>
              <Col span={5}>
                <Div display='flex' flexDirection='column'>
                  <P style={{ width: '100%' }} textAlign='center'>{numeral(report.erpFleetCost).format('0,0.00')}</P>
                  <SmallText color={theme.color.coolGrey} textAlign='center'>({report.erpFleetFuelQuantity || 0} ลิตร)</SmallText>
                </Div>
              </Col>
              <Col span={5}>
                <Div display='flex' flexDirection='column'>
                  <P style={{ width: '100%' }} textAlign='center'>{numeral(report.fleetCardCost).format('0,0.00')}</P>
                  <SmallText color={theme.color.coolGrey} textAlign='center'>({report.fleetCardFuelQuantity || 0} ลิตร)</SmallText>
                </Div>
              </Col>
              <Col span={5}>
                <Div display='flex' flexDirection='column'>
                  {
                    numeral(report.fleetCardCost).format('0,0.00') === numeral(report.erpFleetCost).format('0,0.00')
                    ? <React.Fragment>
                      <P style={{ width: '100%' }} textAlign='center'>ยอดตรงกัน</P>
                      <Icon style={{ alignSelf: 'center' }} margin='2px 0 0' fontSize='16px' icon='fas fa-check-circle' color={theme.color.success} />
                    </React.Fragment>
                    : <React.Fragment>
                      <P style={{ width: '100%' }} bold color={report.erpFleetCost > report.fleetCardCost ? theme.color.success : theme.color.error } textAlign='center'>
                      {
                        report.erpFleetCost > report.fleetCardCost
                          ? '+'
                          : '-'
                      } {
                        numeral(Math.abs((report.erpFleetCost || 0) - (report.fleetCardCost || 0))).format('0,0.00')
                      }
                      </P>
                      {
                        report.fleetCardFuelQuantity !== report.erpFleetFuelQuantity
                        && <SmallText color={theme.color.coolGrey} textAlign='center'>
                          (Fleet Card {report.fleetCardFuelQuantity > report.erpFleetFuelQuantity
                          ? 'มากกว่า' : 'น้อยกว่า'} {Math.abs((report.erpFleetFuelQuantity || 0) - (report.fleetCardFuelQuantity || 0))} ลิตร)
                        </SmallText>
                      }
                    </React.Fragment>
                  }
                </Div>
              </Col>
            </Row>
          </Div>
        ))
      }
    </Modal>
  )
}

export default () => {
  const [importFleetCardModal, setImportFleetCardModal] = useState(false)
  const [exportFuelReportModal, setExportFuelReportModal] = useState(false)
  const [gasstationSummaryModal, setGasstationSummaryModal] = useState(false)
  const [company, setCompany] = useState(ENUM.PADOONGRICH)
  const [gasstationCompany, setGasstationCompany] = useState()
  const [gasstation, setGasstation] = useState()
  const [month, setMonth] = useState(moment())

  const [doImport, { loading: importLoading }] = useMutation(IMPORT_FUEL_COST_SUMMARY)
  const {
    data, loading,
  } = useQuery(FUEL_SUMMARIES_BY_MONTH, { variables: { month, companyType: company } })
  return (
    <Div display='flex' flexDirection='column'>
      <ImportFleetCardModal doImport={doImport} importLoading={importLoading} importFleetCardModal={importFleetCardModal} setImportFleetCardModal={setImportFleetCardModal} />
      <ExportFuelReportModal exportFuelReportModal={exportFuelReportModal} setExportFuelReportModal={setExportFuelReportModal} gasstationCompany={gasstationCompany} />
      <GasstationSummaryModal gasstationSummaryModal={gasstationSummaryModal} setGasstationSummaryModal={setGasstationSummaryModal} month={month} company={company} gasstation={gasstation} />
      <Wrapper overflow padding='0 0 40px 0' flex>
        <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center' padding='0'>
          <H3 bold color={color.primaryColor} margin='32px 0'>ตรวจบิลน้ำมัน</H3>
          <Div display='flex'>
            <Select
              style={{ width: 300, margin: '0 32px 0 0' }}
              onChange={e => setCompany(e)}
              value={company}
            >
              <Select.Option value={ENUM.PADOONGRICH}>{COMPANY_NAME.PADOONGRICH}</Select.Option>
              <Select.Option value={ENUM.TRANSPORT}>{COMPANY_NAME.TRANSPORT}</Select.Option>
            </Select>
            <Div>
              <P margin='0 8px 0 0'>เดือน</P>
              <DatePicker.MonthPicker value={month} allowClear={false} onChange={(e) => {
                setMonth(e)
              }}/>
            </Div>
          </Div>
        </Div>
        <Div margin='0 0 32px' display='flex' flexDirection='row' justifyContent='space-between' alignItems='center' padding='0'>
          <Button
            text='นำเข้าข้อมูลจาก Fleet Card'
            onClick={() => {
              setImportFleetCardModal(true)
            }}
          />
          <Div display='flex'>
            <P margin='0 16px 0 0' color={theme.color.coolGrey}>วันที่เติม</P>
            <P bold>{moment(month).startOf('month').format('YYYY-MM-DD')} - {moment(month).endOf('month').format('YYYY-MM-DD')}</P>
          </Div>
        </Div>
        {
          loading
          ? <Loading center='true' />
          : data?.FuelSummariesByMonth?.data?.map(v => (
            <Collapse defaultActiveKey={['1']} key={nanoid()} style={{ margin: '24px 0' }}>
              <Panel
                key='1'
                header={v.company}
                extra={<Button
                  small
                  margin='-5px 4px 0 0'
                  text='พิมพ์รายงานใบเบิกน้ำมัน'
                  onClick={() => {
                    setExportFuelReportModal(true)
                    setGasstationCompany(v.company)
                  }}
                />}
              >
                {
                  v.companyData.length === 0
                  ? <Div display='flex' width='100%' justifyContent='center'>
                      <P bold>ไม่พบข้อมูล</P>
                    </Div>
                  : <Div width='100%'>
                    <Row style={{ margin: '0', padding: '8px 32px', borderBottom: '1px solid #5278A0' }}>
                      <Col span={1}></Col>
                      <Col span={6}><P bold style={{ width: '100%' }}>ชื่อสถานี</P></Col>
                      <Col span={4}><P bold style={{ width: '100%' }} textAlign='center'>ยอดใน ERP ที่ไม่ใช้ Fleet Card</P></Col>
                      <Col span={4}><P bold style={{ width: '100%' }} textAlign='center'>ยอดใน ERP ที่ใช้ Fleet Card</P></Col>
                      <Col span={3}><P bold style={{ width: '100%' }} textAlign='center'>ยอด Fleet Card</P></Col>
                      <Col span={5}><P bold style={{ width: '100%' }} textAlign='center'>เปรียบเทียบ</P></Col>
                      <Col span={1}></Col>
                    </Row>
                    {
                      v.companyData.map((eachGasstationData, idx) => (
                        <Div key={nanoid()} padding='0 32px' margin='8px 0' bgColor={theme.color.offWhite} style={{ borderRadius: '5px 0 0 5px' }}>
                          <Row type='flex' align='top' style={{ margin: '0' }}>
                            <Col span={1}><P style={{ width: '100%' }} textAlign='center'>{idx + 1}.</P></Col>
                            <Col span={6}><P bold style={{ width: '100%' }}>{eachGasstationData.Gasstation.name}</P></Col>
                            <Col span={4}>
                              <Div display='flex' flexDirection='column'>
                                <P style={{ width: '100%' }} textAlign='center'>{numeral(eachGasstationData.erpNonFleetCost).format('0,0.00')}</P>
                                <SmallText color={theme.color.coolGrey} textAlign='center'>({eachGasstationData.erpNonFleetFuelQuantity || 0} ลิตร)</SmallText>
                              </Div>
                            </Col>
                            <Col span={4}>
                              <Div display='flex' flexDirection='column'>
                                <P style={{ width: '100%' }} textAlign='center'>{numeral(eachGasstationData.erpFleetCost).format('0,0.00')}</P>
                                <SmallText color={theme.color.coolGrey} textAlign='center'>({eachGasstationData.erpFleetFuelQuantity || 0} ลิตร)</SmallText>
                              </Div>
                            </Col>
                            <Col span={3}>
                              <Div display='flex' flexDirection='column'>
                                <P style={{ width: '100%' }} textAlign='center'>{numeral(eachGasstationData.fleetCardCost).format('0,0.00')}</P>
                                <SmallText color={theme.color.coolGrey} textAlign='center'>({eachGasstationData.fleetCardFuelQuantity || 0} ลิตร)</SmallText>
                              </Div>
                            </Col>
                            <Col span={5}>
                              <Div display='flex' flexDirection='column'>
                                {
                                  numeral(eachGasstationData.fleetCardCost).format('0,0.00') === numeral(eachGasstationData.erpFleetCost).format('0,0.00')
                                  ? <React.Fragment>
                                    <P style={{ width: '100%' }} textAlign='center'>ยอดตรงกัน</P>
                                    <Icon style={{ alignSelf: 'center' }} margin='2px 0 0' fontSize='16px' icon='fas fa-check-circle' color={theme.color.success} />
                                  </React.Fragment>
                                  : <React.Fragment>
                                    <P style={{ width: '100%' }} bold color={eachGasstationData.erpFleetCost > eachGasstationData.fleetCardCost ? theme.color.success : theme.color.error } textAlign='center'>
                                    {
                                      eachGasstationData.erpFleetCost > eachGasstationData.fleetCardCost
                                        ? '+'
                                        : '-'
                                    } {
                                      numeral(Math.abs((eachGasstationData.erpFleetCost || 0) - (eachGasstationData.fleetCardCost || 0))).format('0,0.00')
                                    }
                                    </P>
                                    {
                                      eachGasstationData.fleetCardFuelQuantity !== eachGasstationData.erpFleetFuelQuantity
                                      && <SmallText color={theme.color.coolGrey} textAlign='center'>
                                        (Fleet Card {eachGasstationData.fleetCardFuelQuantity > eachGasstationData.erpFleetFuelQuantity
                                        ? 'มากกว่า' : 'น้อยกว่า'} {Math.abs((eachGasstationData.erpFleetFuelQuantity || 0) - (eachGasstationData.fleetCardFuelQuantity || 0))} ลิตร)
                                      </SmallText>
                                    }
                                  </React.Fragment>
                                }
                              </Div>
                            </Col>
                            <Col span={1}>
                              <Icon
                                style={{ alignSelf: 'center', cursor: 'pointer' }}
                                fontSize='16px'
                                icon='fas fa-eye'
                                color={theme.color.snomo}
                                onClick={() => {
                                  setGasstation(eachGasstationData.Gasstation)
                                  setGasstationSummaryModal(true)
                                }}
                              />
                            </Col>
                          </Row>
                        </Div>
                      ))
                    }
                  </Div>
                }
              </Panel>
            </Collapse>
          ))
        }
      </Wrapper>
    </Div>
  )
}
